var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardioMachine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.6665 136.167C45.9182 136.167 34.044 136.167 25.7199 129.783C23.0316 127.721 20.6675 125.226 18.7143 122.388C12.6665 113.602 12.6665 101.068 12.6665 75.9999C12.6665 50.9323 12.6665 38.3984 18.7143 29.6119C20.6675 26.7742 23.0316 24.2788 25.7199 22.2171C34.044 15.8333 45.9182 15.8333 69.6665 15.8333H82.3332C106.081 15.8333 117.956 15.8333 126.28 22.2171C128.968 24.2788 131.332 26.7742 133.285 29.6119C139.333 38.3984 139.333 50.9323 139.333 75.9999C139.333 101.068 139.333 113.602 133.285 122.388C131.332 125.226 128.968 127.721 126.28 129.783C117.956 136.167 106.081 136.167 82.3332 136.167H69.6665Z",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6665 136.167C45.9182 136.167 34.044 136.167 25.7199 129.783C23.0316 127.721 20.6675 125.226 18.7143 122.388C12.6665 113.602 12.6665 101.068 12.6665 75.9999C12.6665 50.9323 12.6665 38.3984 18.7143 29.6119C20.6675 26.7742 23.0316 24.2788 25.7199 22.2171C34.044 15.8333 45.9182 15.8333 69.6665 15.8333H82.3332C106.081 15.8333 117.956 15.8333 126.28 22.2171C128.968 24.2788 131.332 26.7742 133.285 29.6119C139.333 38.3984 139.333 50.9323 139.333 75.9999C139.333 101.068 139.333 113.602 133.285 122.388C131.332 125.226 128.968 127.721 126.28 129.783C117.956 136.167 106.081 136.167 82.3332 136.167H69.6665Z",
    stroke: "url(#paint0_linear_16725_942)",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 95H136.167",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 95H136.167",
    stroke: "url(#paint1_linear_16725_942)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3902 114H44.3335",
    stroke: "white",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3902 114H44.3335",
    stroke: "url(#paint2_linear_16725_942)",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6669 114H69.6099",
    stroke: "white",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6669 114H69.6099",
    stroke: "url(#paint3_linear_16725_942)",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3902 114H44.3335M69.6668 114H69.6098",
    stroke: "white",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3902 114H44.3335M69.6668 114H69.6098",
    stroke: "url(#paint4_linear_16725_942)",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.667 64.5999C104.783 64.5999 101.748 64.7785 99.1605 63.1882C98.1738 62.582 97.5189 61.744 96.2098 60.0682L83.9168 44.3333L68.0835 69.6666L56.6416 58.6823C55.0192 57.1249 53.4375 55.5459 51.2903 54.9211C49.7288 54.4666 47.9303 54.4666 44.3335 54.4666",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.667 64.5999C104.783 64.5999 101.748 64.7785 99.1605 63.1882C98.1738 62.582 97.5189 61.744 96.2098 60.0682L83.9168 44.3333L68.0835 69.6666L56.6416 58.6823C55.0192 57.1249 53.4375 55.5459 51.2903 54.9211C49.7288 54.4666 47.9303 54.4666 44.3335 54.4666",
    stroke: "url(#paint5_linear_16725_942)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16725_942",
    x1: 12.6665,
    y1: 15.8333,
    x2: 161.988,
    y2: 60.5973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16725_942",
    x1: 15.8335,
    y1: 95,
    x2: 15.965,
    y2: 99.5075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16725_942",
    x1: 44.3335,
    y1: 114,
    x2: 44.4064,
    y2: 114.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16725_942",
    x1: 69.6099,
    y1: 114,
    x2: 69.6831,
    y2: 114.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16725_942",
    x1: 44.3335,
    y1: 114,
    x2: 44.947,
    y2: 118.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_16725_942",
    x1: 44.3335,
    y1: 44.3333,
    x2: 98.3311,
    y2: 82.7788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A97B27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardioMachine);
export default __webpack_public_path__ + "static/media/cardio-machine.6a703f4f7b63fa1640af24ee6713d7b3.svg";
export { ForwardRef as ReactComponent };